import DOMPurify from 'dompurify';
import { log } from './logger';

const ALLOWED_TAGS = [
  // Document structure
  'html', 'head', 'body', 'title', 'meta', 'link', 'base',
  // Sections
  'article', 'section', 'nav', 'aside', 'header', 'footer', 'main', 'address',
  // Headings
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hgroup',
  // Content grouping
  'p', 'hr', 'pre', 'blockquote', 'ol', 'ul', 'li', 'dl', 'dt', 'dd',
  'figure', 'figcaption', 'div',
  // Text semantics
  'a', 'em', 'strong', 'small', 's', 'cite', 'q', 'dfn', 'abbr',
  'data', 'time', 'code', 'var', 'samp', 'kbd', 'sub', 'sup',
  'i', 'b', 'u', 'mark', 'ruby', 'rb', 'rt', 'rtc', 'rp',
  'bdi', 'bdo', 'span', 'br', 'wbr', 'del', 'ins',
  // Embedded content
  'img', 'picture', 'source', 'iframe', 'embed', 'object', 'param',
  'video', 'audio', 'track', 'map', 'area', 'svg', 'math',
  // Tables
  'table', 'caption', 'colgroup', 'col', 'thead', 'tbody', 'tfoot', 'tr', 'th', 'td',
  // Forms
  'form', 'label', 'input', 'button', 'select', 'datalist', 'optgroup', 'option',
  'textarea', 'output', 'progress', 'meter', 'fieldset', 'legend',
  // Interactive
  'details', 'summary', 'dialog', 'menu',
  // Canvas
  'canvas',
  // Template
  'template', 'slot',
];

const ALLOWED_ATTR = [
  // Global
  'id', 'class', 'style', 'title', 'lang', 'dir', 'hidden', 'tabindex',
  'accesskey', 'draggable', 'contenteditable', 'spellcheck', 'translate',
  'role', 'aria-*', 'data-*',
  // Links & media
  'href', 'src', 'srcset', 'sizes', 'alt', 'loading', 'decoding',
  'crossorigin', 'referrerpolicy', 'target', 'rel', 'download',
  'type', 'media', 'poster', 'preload', 'autoplay', 'loop', 'muted', 'controls',
  'width', 'height', 'usemap', 'ismap',
  // Tables
  'colspan', 'rowspan', 'headers', 'scope', 'abbr',
  // Forms
  'name', 'value', 'placeholder', 'required', 'disabled', 'readonly',
  'checked', 'selected', 'multiple', 'size', 'maxlength', 'minlength',
  'min', 'max', 'step', 'pattern', 'list', 'autocomplete', 'autofocus',
  'form', 'formaction', 'formmethod', 'formenctype', 'formnovalidate', 'formtarget',
  'for', 'rows', 'cols', 'wrap',
  // Time & data
  'datetime', 'open', 'cite', 'reversed', 'start',
  // SVG
  'viewBox', 'xmlns', 'fill', 'stroke', 'stroke-width', 'd', 'cx', 'cy', 'r',
  'x', 'y', 'x1', 'x2', 'y1', 'y2', 'points', 'transform',
];

export function sanitizeHtml(html: string): string {
  const clean = DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    ALLOW_DATA_ATTR: true,
    ALLOW_ARIA_ATTR: true,
    ADD_TAGS: ['style'],
    ADD_ATTR: ['target'],
  });
  log.info('Sanitized HTML', { inputLength: html.length, outputLength: clean.length });
  return clean;
}
